export default [
    {
        path: '/article/index',
        component: (resolve) => require(['@/components/article/Index'],resolve),
        meta: {
            title: '资讯列表'
        },
    },
    {
        path: '/article/Detail',
        component: (resolve) => require(['@/components/article/Detail'],resolve),
        meta: {
            title: '资讯详情',
        },
    },
    {
        path: '/article/User',
        component: (resolve) => require(['@/components/article/User'],resolve),
        meta: {
            title: '阅读记录',
        },
    },
]


// WEBPACK FOOTER //
// ./src/router/article.js